import Service from "../Services/service";

export async function PermissionListHooks(searchTerm, sortBy, sortDescending, pageNumber, pageSize) {
    var data;
    await Service.getdata("Permission/GetAll?searchTerm=" + searchTerm + "&sortBy=" + sortBy + "&sortDescending=" + sortDescending + "&pageNumber=" + pageNumber + "&pageSize=" + pageSize).then((res) => {
        data = res.data;
    });
    return data;
}

export async function CreateUserPermission(formData) {
    var data;
    await Service.createorupdate("Permission/CreateOrUpdate", formData)
        .then(res => {
            //  setApiResponse(res.data); // Set the API response in state  
            data = res.data;
        })
        .catch(error => {
            // Handle error if API call fails
            console.error("API Error:", error);

        });
    return data;
}

export async function CreateUserRowPermission(formData) {
    var data;
    await Service.createorupdate("Permission/CreateOrUpdateRowPermission", formData)
        .then(res => {
            //  setApiResponse(res.data); // Set the API response in state  
            data = res.data;
        })
        .catch(error => {
            // Handle error if API call fails
            console.error("API Error:", error);

        });
    return data;
}